/**
 * ProductHighlights - product highlights/USP block.
 * Custom element: <product-highlights>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class ProductHighlights extends ThemeComponent {}
setFunctionName(ProductHighlights, "ProductHighlights");
const propertyTypes = {};
ProductHighlights.prototype.$name = "ProductHighlights";
ProductHighlights.prototype.$info = JSON.parse('{"name":"ProductHighlights","meta":{"isLegacy":false,"selector":"product-highlights"},"props":[],"refs":[]}');
ProductHighlights.prototype.$info.component = ProductHighlights;
for (const prop of ProductHighlights.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Product/ProductHighlights.ts", {
  ProductHighlights: ProductHighlights
}, void 0);